import { useMutation } from '@apollo/client';

import {
  CreateBankTransferRecipientDocument,
  CreateBankTransferRecipientMutationVariables,
} from './createBankTransferRecipient.gql';

export const useCreateBankTransferRecipient = () => {
  const [createBankTransferRecipientMutation, { loading }] = useMutation(
    CreateBankTransferRecipientDocument,
  );

  const createBankTransferRecipient = async ({
    input,
    token,
  }: {
    input: CreateBankTransferRecipientMutationVariables['input'];
    token: string;
  }) => {
    return createBankTransferRecipientMutation({
      context: {
        headers: {
          'short-lived-token': token,
        },
      },
      variables: {
        input,
      },
    });
  };

  return { createBankTransferRecipient, loading };
};
